// extracted by mini-css-extract-plugin
export var base = "_40-0";
export var updateBanner = "_40-1";